import { getAPIHeaders } from "../app/utils";
import { serverApi } from "../services";

export const getSolutions = async (payload) => {
  try {
    const reqOpts = getAPIHeaders(payload);
    const response = await serverApi.get("solutions", reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postSolution = async (payload) => {
  try {
    const reqOpts = getAPIHeaders();
    const response = await serverApi.post("solutions", payload, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const putSolution = async ({ id, payload }) => {
  try {
    const reqOpts = getAPIHeaders({ SOLUTION_ID: id });
    const response = await serverApi.put(`solutions`, payload, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};
